import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions as cartActions } from 'features/Cart'
import ActionButton from 'Shared/Button/ActionButton'
import PropTypes from 'prop-types'
import yn from 'yn'

class AddToCartButton extends Component {
  constructor (props) {
    super(props)
    this.state = {
      clickToRemove: false
    }
    this.AddItemCart = this.AddItemCart.bind(this)
  }

  AddItemCart = () => {
    if (yn(process.env.REACT_APP_HAS_VERIFY_CART_PARTNER) && this.props.onlyCash) {
      if (this.props.items.length === 0 || (this.props.items.length > 0 && this.props.vendorId === (this.props.items[0].vendor.id).toString())) {
        this.props.onClick()
      } else {
        this.props.items.map((item, index) => {
          this.props.vendorId !== (this.props.items[0].vendor.id).toString() && this.props.removeItem(item.sku)
        })
        this.setState({ clickToRemove: true })
      }
    } else {
      this.props.onClick()
    }
  }
  render () {
    if (this.state.clickToRemove && this.props.itemsToRemove.skus.length === 0) {
      this.props.onClick()
      this.setState({ clickToRemove: false })
    }
    return <ActionButton AddItemCart={this.AddItemCart} {...this.props} />
  }
}

const mapStateToProps = ({ cart, oidc, itemsToRemove, onlyCash }) => {
  return ({
    items: cart.items,
    isLoading: cart.isLoadingRedirect,
    hasSuccess: cart.itemAdded,
    email: oidc && oidc.user && oidc.user.profile && oidc.user.profile.email,
    itemsToRemove: itemsToRemove,
    onlyCash: onlyCash
  })
}

const mapDispatchToProps = (dispatch, { sku, vendorId, goToCheckout }) => ({
  onClick: email => () => dispatch(cartActions.addItem({ sku, vendorId, email }, goToCheckout)),
  removeItem: sku => dispatch(cartActions.removeItem(sku)),
  loadCart: () => dispatch(cartActions.loadCart())
})

const mergeProps = ({ email, ...stateProps }, { onClick, removeItem }, own) => {
  return ({
    ...stateProps,
    onClick: onClick(email),
    removeItem: removeItem,
    ...own
  })
}
AddToCartButton.propTypes = {
  onClick: PropTypes.func,
  removeItem: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  wasModified: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  vendorId: PropTypes.string,
  itemsToRemove: PropTypes.object,
  onlyCash: PropTypes.bool
}

AddToCartButton.defaultProps = {
  errorText: 'Erro ao adicionar',
  successText: 'Adicionado',
  text: 'Adicionar ao carrinho'
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AddToCartButton)



// WEBPACK FOOTER //
// ./src/Checkout/Cart/AddToCartButton.js